<template>
  <div>

    <div class="background-window" @mousedown.self="onMouseDown" @mouseup.self="onMouseUp">
      <div class="window-param">
        <div class="head-window">
          <h2 class="name-window-param middle-high">{{ nameWindow }}</h2>
          <button @click="closeWindow">
            <img src="@/assets/imgs/crosser-black.svg" alt="">
          </button>
        </div>
        <div class="body-window">
          <el-form :model="form" label-width="auto" style="max-width: 600px">

            <!-- Name -->
            <el-form-item :label="nameLine">
              <el-input v-model="form.name" :disabled="userOptions.role == 'viewer' || userType == 'demo'"/>
            </el-form-item>

            <!-- MAC address -->
            <el-form-item :label="addressLine">
              <el-input v-model="form.mac" disabled>
                <template #suffix>
                  <img v-if="addition && (userOptions.role != 'viewer' && userType != 'demo')" style="cursor: pointer;
                    margin-left: 4px;
                    padding-left: 0.5%;
                    width: 16px;" @click="seeAllInfo()" src="@/assets/imgs/quation.png"
                  >
                </template>
              </el-input>
            </el-form-item>

            <!-- Date of creating -->
            <el-form-item label="Дата регистрации">
              <el-input v-model="form.date" disabled/>
            </el-form-item>

            <!-- Group of sensor sensetive -->
            <el-form-item label="Группа датчика">
              <el-select  v-model="form.group" placeholder="Select" :disabled="userOptions.role != 'developer'">
                <el-option v-for="item in groups" :key="item" :label="item" :value="item" />
                <template #footer>
                  <el-button v-if="!isAdding" text bg size="small" @click="isAdding = true">
                    Добавить конкретное значение
                  </el-button>
                  <template v-else>
                    <div>
                      <el-input
                        v-model="optionName"
                        type="number"
                        class="option-input"
                        placeholder="значение вибрации, мм/с"
                        size="small"
                      />
                    </div>
                    <div style="margin-top: 10px">
                      <el-button type="primary" size="small" @click="onConfirmAdditionOption">Добавить</el-button>
                      <el-button size="small" @click="isAdding = false">Отменить</el-button>
                    </div>
                  </template>
                </template>
              </el-select>
              <label v-if="form.group && form.group !== 'Без группы' && userType != 'demo' && form.group != groups[4]" style="margin: 0;">
                <input type="checkbox" v-model="form.is_new" :disabled="userOptions.role != 'developer'">
                Новый
              </label>
            </el-form-item>

            <!-- Company  -->
            <el-form-item label="Название компании" v-show="userOptions.role == 'developer'">
              <el-select v-model="form.company_id" placeholder="Select" :disabled="userOptions.role != 'developer'">
                <el-option v-for="item in companyList" :key="item.label" :label="item.label" :value="item.id" />
              </el-select>
            </el-form-item>

            <!-- MotoResourse -->
            <el-form-item label="Моторесурс" v-show="userOptions.role == 'developer'">
              <div style="display: flex; flex-direction: column; width: 100%;">
                <el-input type="number" v-model="form.moto" @keydown="blockInvalidChars" placeholder="Часы, напр. 100.0 " :disabled="userType == 'demo'"  />
                <el-alert type="info" :closable="false" style="margin-top: 6px; width: 100%; height: 23px;">
                  <p>{{ motoHandeler }}</p>
                </el-alert>
              </div>
            </el-form-item>

            <!-- Power -->
            <el-form-item label="Мощность, кВт" v-show="userOptions.role == 'developer'">
              <el-input type="number" v-model="form.power" @keydown="blockInvalidChars" placeholder="кВт, напр. 4.0" :disabled="userType == 'demo'"  />
            </el-form-item>

            <!-- RMP -->
            <el-form-item label="Обороты, об/мин" v-show="userOptions.role == 'developer'">
              <el-input type="number" v-model="form.rpm" @keydown="blockInvalidChars" placeholder="об/мин, напр. 1500.0" :disabled="userType == 'demo'" />
            </el-form-item>

            <!-- Showing elements -->
            <el-form-item label="Что отображать">
              <el-checkbox-group v-model="form.showing">
                <el-checkbox label="power" value="power" :disabled="userType == 'demo'">Мощность, кВт</el-checkbox>
                <el-checkbox label="rpm" value="rpm" :disabled="userType == 'demo'">Обороты, об/мин</el-checkbox>
                <el-checkbox label="machine" value="machine" :disabled="userType == 'demo' || !sensorImage">Механизм</el-checkbox>
                <el-checkbox label="place" value="place" :disabled="userType == 'demo' || !placeImage">Место установки</el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <!-- Image Loader -->
            <el-form-item label="Механизм">
              <div v-if="sensorImage">
                <img :src="sensorImage" style="max-width: 100%; height: auto;" />
                <!-- <div class="icon-witch-image">
                  <img src="@/assets/imgs/eye.svg" style="max-width: 100%; height: auto;" />
                </div> -->
                <el-button @click="deleteImageLocal({ mac, type: 'Sensor' })" :disabled="userType == 'demo'">
                  Удалить фото
                </el-button>
              </div>

              <el-button v-else @click="triggerFileInput('Sensor')" :disabled="userType == 'demo'">
                Загрузить фото
              </el-button>
            </el-form-item>

            <el-form-item label="Место Установки">
              <div v-if="placeImage">
                <img :src="placeImage" style="max-width: 100%; height: auto;" />
                <!-- <div class="icon-witch-image">
                  <img src="@/assets/imgs/eye.svg" style="max-width: 100%; height: auto;" />
                </div> -->
                <el-button @click="deleteImageLocal({ mac, type: 'Place' })" :disabled="userType == 'demo'">
                  Удалить фото
                </el-button>
              </div>
              <div v-else>
                <el-button @click="triggerFileInput('Place')" :disabled="userType == 'demo'">
                  Загрузить фото
                </el-button>
              </div>
            </el-form-item>
            
            <el-form-item>
              <el-button type="primary" @click="postData">Применить</el-button>
              <el-button @click="closeWindow">Отменить</el-button>
            </el-form-item>
            <input type="file" ref="fileInput" @change="handleFileSelect" accept="image/*" style="display:none" />
          </el-form>
         
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: "WindowParam",
  emits: ['closeWindow'],
  props: ['id', 'mac', 'name_element', 'date', 'company_id', 'addition_params', 'typeWindow', 'power', 'rpm', 'motor_life_offset', 'motor_life_start', 'total_time', 'addition', 'groupSensor',
          'isNewGroup', 'warn', 'agreement', 'showPlaceImage', 'showSensorImage', 'userType', 'custom_level_vibrations'],

  data() {
    return {
      isMouseDownOnBg: false,
      groups: ['Без группы', 'Группа 1', 'Группа 2', 'Группа 3'],
      form: {
        name: '',
        mac: '',
        date: '',
        group: '',
        company_id: 0,
        moto: '',
        power: '',
        rpm: '',
        showing: []
      },
      group: null,
      isNew: false,
      name: '',
      companyId: null,
      typeOfImage: '',
      moto1: '',
      additionalParam: [],
      shouldPowerShow: false,
      shouldRpmShow: false,
      shouldShowSensorImage: false,
      shouldShowPlaceImage: false,
      additionalList: [
        {
          id: 1,
          label: 'Обороты',
          value: 'rpm'
        },
        {
          id: 2,
          label: 'Мощность',
          value: 'power'
        }
      ],
      isAdding: false,
      optionName: ''
    }
  },
  computed: {
    nameWindow() {
      if (this.name_element) {
        return this.name_element
      } else {
        return this.mac
      }
    },
    nameLine() {
      if (this.typeWindow == 'sensor') {
        return 'Наименование датчика'
      } else if (this.typeWindow == 'counter') {
        return 'Наименование счетчика'
      }
    },
    addressLine() {
      if (this.typeWindow == 'sensor') {
        return 'MAC адрес'
      } else if (this.typeWindow == 'counter') {
        return 'Адрес'
      }
    },
    ...mapGetters('user', {
      userOptions: 'getUserOptions',
    }),
    ...mapGetters('sensors', {
      companyList: 'getCompanyList',
      getSensorImage: 'getSensorImage',
      getPlaceImage: 'getPlaceImage',
      getSensorImageObj: 'getSensorImageObj',
      getPlaceImageObj: 'getPlaceImageObj'
    }),
    sensorImage() {
      return this.getSensorImage(this.mac)
    },
    placeImage() {
      return this.getPlaceImage(this.mac)
    },
    motoHandeler() {
      if ((this.motor_life_offset+this.motor_life_start) > this.total_time) {
        return ((this.motor_life_offset+this.motor_life_start-this.total_time)/60).toFixed(2) + ' ч осталось'
      } else {
        return 'Время вышло'
      }
    },
  },
  methods: {
    ...mapActions('sensors', {
      setSensorSettings: 'putSensorSettings',
      getCompanyList: 'getApiCompanyList',
      fetchImage: 'fetchImage',
      uploadImageLocal: 'uploadImageLocal',
      deleteImageLocal: 'deleteImageLocal',
    }),
    ...mapMutations('sensors', {
      setLocalImagesClean: 'setLocalImagesClean'
    }),
    onMouseDown() {
      this.isMouseDownOnBg = true
    },
    onMouseUp() {
      if (this.isMouseDownOnBg) {
        this.closeWindow()
      }
      this.isMouseDownOnBg = false
    },
    onConfirmAdditionOption() {
      if (this.optionName) {
        if (this.groups.length == 4) {
          this.groups.push(this.optionName)
        } else {
          this.groups[4] = this.optionName
        }
      }
      this.isAdding = false
    },
    closeWindow() {
      this.setLocalImagesClean()
      this.$emit('closeWindow')
    },

    seeAllInfo() {
      this.$router.push(`/${this.mac}`)
    },

    blockInvalidChars(e) {
      const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', '.'];
      if (
        !allowedKeys.includes(e.key) &&
        (isNaN(Number(e.key)) || e.key === 'e' || e.key === 'E')
      ) {
        e.preventDefault();
      }
    },


    handleFileSelect(e) {
      const file = e.target.files[0]
      if (file) {
        this.uploadImageLocal({ mac: this.mac, type: this.typeOfImage, file })
      }
      e.target.value = ''
    },

    triggerFileInput(type) {
      this.typeOfImage = type
      this.$refs.fileInput.click()
    },


    async postData() {
      let options = {
        name: this.form.name,
        id: this.id,
        power: this.form.power,
        rpm: this.form.rpm,
        company_id: this.form.company_id,
        type_element: this.typeWindow,
        group: this.form.group != this.groups[4] ? this.form.group : null,
        is_new: this.form.is_new === true ? 1 : 0,
        custom_vibro_level: this.form.group == this.groups[4]? Number(this.form.group):null,
        moto_resourse: typeof Number(this.form.moto) === 'number' ? this.form.moto : '',
        sensor_image: this.getSensorImageObj(this.mac)?.file || '',
        sensor_image_place: this.getPlaceImageObj(this.mac)?.file || '',
        showing: this.form.showing,
      }
      options.showing = this.form.showing.filter(el=> {
        if (el=='machine' && options.sensor_image == '') {
          return false
        } 
        if (el=='place' && options.sensor_image_place == '') {
          return false
        }
        return true
      })
      console.log(options)
      await this.setSensorSettings(options)
      this.closeWindow()
    },
    
    initForm() {
      Object.assign(this.form, {
        name: this.name_element,
        mac: this.mac,
        date: this.date,
        power: this.power,
        rpm: this.rpm,
        is_new: this.isNewGroup,
        group: this.groupSensor,
        company_id: this.company_id,
        showing: this.addition_params,
        moto: this.motor_life_offset?this.motor_life_offset/60:''
      })
      if (this.showPlaceImage) {
        this.form.showing.push('place')
      }
      if (this.showSensorImage) {
        this.form.showing.push('machine')
      }
      if (this.custom_level_vibrations) {
        this.groups.push(String(this.custom_level_vibrations))
        this.form.group = String(this.custom_level_vibrations)
      }
    }
  },

  async created() {
    this.initForm()
    // this.moto1 = this.motor_life_offset/60
    await Promise.all([
      this.getCompanyList(),
      this.fetchImage({ mac: this.mac, type: 'Sensor' }),
      this.fetchImage({ mac: this.mac, type: 'Place' })
    ]);
    this.shouldShowPlaceImage = this.showPlaceImage
    this.shouldShowSensorImage = this.showSensorImage
    this.shouldRpmShow = this.addition_params.findIndex(el=>el=='rpm') != -1?true:false
    this.shouldPowerShow = this.addition_params.findIndex(el=>el=='power') != -1?true:false
  },

  watch: {
  },
  beforeUnmount() {
  }
}
</script>

<style scoped lang="scss">



.background-window {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.295);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  height: 100%;
}

.window-param {
  background: var(--background-white, #FCFCFC);
  cursor: auto;
  width: 30vw;
  min-width: 398px;
  border-radius: 4px;
  padding: 0px 20px;
  display: flex;
  flex-direction: column;
  max-height: 85%;
  overflow-y: auto;

  .option-input {
    width: 100px;
  }

  .icon-witch-image {
    padding: 3px;
    margin-right: 5px;
    cursor: pointer;
  }

  .head-window {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;

    button {
      padding: 1px 2px;
      background: none;
      cursor: pointer;
    }
  }


  .body-window {
    align-self: center;
  }

}

@media screen and (max-width: 420px) {
  .window-param {
    width: 361px;
    min-width: 361px;

    .middle-high {
      font-family: Lato;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
}
</style>
